export default __webpack_public_path__ + "static/media/verticalLbranca.58dcf7d5.png";